import { render } from "./AddEditSchool.vue?vue&type=template&id=73fd7e2a&scoped=true"
import script from "./AddEditSchool.vue?vue&type=script&lang=js"
export * from "./AddEditSchool.vue?vue&type=script&lang=js"

import "./AddEditSchool.vue?vue&type=style&index=0&id=73fd7e2a&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73fd7e2a"]])

export default __exports__